
class FaBullets {
  // 1. describe and create/initiate our object
  constructor() {
    this.bulletsUL = document.querySelector(".fa-bullets");
    this.bulletsLI = document.querySelectorAll(".fa-bullets > li");
    this.events()
  }

  // 2. events
  events() {
    if (this.bulletsUL) {
      this.bulletsUL.classList.add("fa-ul");
      this.bulletsLI.forEach(item => this.addBullets(item));
    }
  }

  // 3. methods (function, action...)

  addBullets(item) {
    let content = item.innerHTML;
    let newContent = "<span class='fa-li'><i class='fa-sharp fa-solid fa-circle-check'></i></span>" + content;
    item.innerHTML = newContent;
  }
  
}

export default FaBullets
